import { render, staticRenderFns } from "./Canvas3D.vue?vue&type=template&id=3b6b4a94&"
import script from "./Canvas3D.vue?vue&type=script&lang=js&"
export * from "./Canvas3D.vue?vue&type=script&lang=js&"
import style0 from "./Canvas3D.vue?vue&type=style&index=0&id=3b6b4a94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports